import { render, staticRenderFns } from "./addLeave.vue?vue&type=template&id=ab86d16e&scoped=true&"
import script from "./addLeave.vue?vue&type=script&lang=js&"
export * from "./addLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab86d16e",
  null
  
)

export default component.exports